import * as Haptics from 'expo-haptics';
import { Platform } from 'react-native';

/**
 * Light tap-back for positive micro-interactions (e.g. liking a check-in).
 * No-op on web; never throws so it can never break the interaction it accompanies.
 */
export async function likeHaptic(): Promise<void> {
  if (Platform.OS === 'web') return;
  try {
    await Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Heavy);
  } catch {
    // Haptics are best-effort; ignore unsupported-device / permission errors.
  }
}
